import { useState, useEffect } from 'react';
import { queryStudioIdOfBIDS } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverallDetail';
import { ENV } from '@home/_config/config';

const BIDS_URL_MAP = {
  dev: 'http://prerelease.bids.woa.com',
  test: 'http://prerelease.bids.woa.com',
  pre: 'https://bids.woa.com',
  pro: 'https://bids.woa.com',
};

// 跳转BISD系统相关的
export default function useBIDSLinker(studioId: string) {
  // BIDS系统链接
  const [BIDSSystemURL, setBIDSSystemURL] = useState('');

  /**
   * BIDS系统链接只读取一次即可
   */
  useEffect(() => {
    (async () => {
      // 不同环境需要配置
      const BIDS_DOMAIN = BIDS_URL_MAP?.[ENV] || '';
      if (!BIDS_DOMAIN || !studioId) {
        setBIDSSystemURL('');
        return;
      }
      const studioIdOfBIDS = await queryStudioIdOfBIDS({ studio_id: studioId });
      const encodedStudioIdOfBIDS = window.encodeURIComponent(studioIdOfBIDS);
      const url = `${BIDS_DOMAIN}/post-deal/director/${encodedStudioIdOfBIDS}/records`;
      const encodedUrl = window.encodeURI(url);
      setBIDSSystemURL(encodedUrl);
    })();

    return () => {
      setBIDSSystemURL('');
    };
  }, [studioId]);

  return BIDSSystemURL;
}
